(function () {
  "use strict";

  // find this exact script tag to read its data attribute
  var scriptTags = document.querySelectorAll('script[data-carousel-init]');
  var thisScript = scriptTags[scriptTags.length - 1];
  var sectionId = thisScript ? thisScript.getAttribute('data-section-id') : null;

  var wrapper = document.getElementById("marqueeWrapper-" + sectionId);
  var track   = document.getElementById("marqueeTrack-" + sectionId);

  if (!wrapper || !track) return;

  // ---------------------------------------------------------------
  // 1. BUILD THE TRACK
  //    Unlike the static demo, our "group" already exists in the DOM
  //    (rendered by Liquid from section.blocks). We clone that one
  //    group until a "set" is wider than the viewport, then duplicate
  //    the whole set once more so we have two identical, adjacent
  //    sets to wrap between.
  // ---------------------------------------------------------------

  var setWidth = 0;
  var sourceGroupHTML = null;

  function buildTrack() {
    var wrapperWidth = wrapper.clientWidth;

    // capture the original Liquid-rendered group once
    if (sourceGroupHTML === null) {
      var firstGroup = track.querySelector(".marquee-group");
      if (!firstGroup) return;
      sourceGroupHTML = firstGroup.outerHTML;
    }

    track.innerHTML = "";

    var setEl = document.createElement("div");
    setEl.style.display = "flex";
    track.appendChild(setEl);

    var width = 0;
    // guard against an infinite loop if there are zero/near-zero width items
    var safety = 0;
    while (width < wrapperWidth + 200 && safety < 50) {
      var temp = document.createElement("div");
      temp.innerHTML = sourceGroupHTML;
      setEl.appendChild(temp.firstElementChild);
      width = setEl.getBoundingClientRect().width;
      safety++;
    }

    setWidth = width;

    var clone = setEl.cloneNode(true);
    track.appendChild(clone);
  }

  buildTrack();
  if (!setWidth) return; // nothing to animate (no blocks)

  // ---------------------------------------------------------------
  // 2. STATE
  // ---------------------------------------------------------------

  var BASE_SPEED = 0.6;
  var EASE_TO_BASE = 0.05;

  var position = 0;
  var velocity = BASE_SPEED;

  var isDragging = false;
  var dragStartX = 0;
  var dragStartPos = 0;
  var lastX = 0;
  var lastTime = 0;
  var recentVelocity = 0;
  var dragDistance = 0;
  var suppressClick = false;

  // ---------------------------------------------------------------
  // 3. RENDER LOOP
  // ---------------------------------------------------------------

  function render() {
    if (!isDragging) {
      if (Math.abs(velocity - BASE_SPEED) > 0.001) {
        velocity += (BASE_SPEED - velocity) * EASE_TO_BASE;
      } else {
        velocity = BASE_SPEED;
      }
      position += velocity;
    }

    var wrapped = ((position % setWidth) + setWidth) % setWidth;
    track.style.transform = "translate3d(" + (-wrapped) + "px, 0, 0)";

    requestAnimationFrame(render);
  }
  requestAnimationFrame(render);

  // ---------------------------------------------------------------
  // 4. POINTER INTERACTION
  // ---------------------------------------------------------------

  function onPointerDown(e) {
    isDragging = true;
    wrapper.classList.add("dragging");
    wrapper.setPointerCapture(e.pointerId);

    dragStartX = e.clientX;
    dragStartPos = position;
    lastX = e.clientX;
    lastTime = performance.now();
    recentVelocity = 0;
    dragDistance = 0;
  }

  function onPointerMove(e) {
    if (!isDragging) return;

    var now = performance.now();
    var dx = e.clientX - lastX;
    var dt = Math.max(now - lastTime, 1);

    position = dragStartPos - (e.clientX - dragStartX);
    dragDistance += Math.abs(dx);

    recentVelocity = (-dx / dt) * 16.7;

    lastX = e.clientX;
    lastTime = now;
  }

  function onPointerUp(e) {
    if (!isDragging) return;
    isDragging = false;
    wrapper.classList.remove("dragging");
    try { wrapper.releasePointerCapture(e.pointerId); } catch (_) {}

    velocity = recentVelocity;

    // if the user actually dragged (not just clicked), swallow the
    // click so it doesn't fire the underlying <a> link
    if (dragDistance > 5) {
      suppressClick = true;
    }
  }

  wrapper.addEventListener("pointerdown", onPointerDown);
  wrapper.addEventListener("pointermove", onPointerMove);
  wrapper.addEventListener("pointerup", onPointerUp);
  wrapper.addEventListener("pointercancel", onPointerUp);

  wrapper.addEventListener("click", function (e) {
    if (suppressClick) {
      e.preventDefault();
      e.stopPropagation();
      suppressClick = false;
    }
  }, true);

  wrapper.addEventListener("dragstart", function (e) { e.preventDefault(); });

  // ---------------------------------------------------------------
  // 5. RESPONSIVE
  // ---------------------------------------------------------------

  var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var wrapped = ((position % setWidth) + setWidth) % setWidth;
      buildTrack();
      position = wrapped;
    }, 150);
  });

})();